export const PROFILE_TYPE_OPTIONS = Object.freeze([
  {
    value: "homme",
    label: "Homme",
    emoji: "🧔",
    supportingLabel: "Je participe seul",
    icon: "homme",
  },
  {
    value: "femme",
    label: "Femme",
    emoji: "💃",
    supportingLabel: "Je participe seule",
    icon: "femme",
  },
  {
    value: "couple",
    label: "Couple",
    emoji: "👫",
    supportingLabel: "On participe à deux",
    icon: "couple",
  },
]);

export const PROFILE_TYPE_SELECTION_OPTIONS = PROFILE_TYPE_OPTIONS;

export const GENDER_IDENTITY_OPTIONS = Object.freeze([]);

const PROFILE_TYPE_ALIASES = Object.freeze({
  duo: "couple",
  man: "homme",
  male: "homme",
  masculine: "homme",
  woman: "femme",
  female: "femme",
  feminine: "femme",
  solo: "homme",
  single: "homme",
});

function normalizeIdentityToken(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function normalizeOptionValue(value, options, aliases = {}) {
  const token = normalizeIdentityToken(value);

  if (!token) {
    return "";
  }

  const directMatch = options.find((option) => option.value === token);

  if (directMatch) {
    return directMatch.value;
  }

  return aliases[token] || "";
}

export function normalizeProfileType(value) {
  return normalizeOptionValue(value, PROFILE_TYPE_OPTIONS, PROFILE_TYPE_ALIASES);
}

export function normalizeGenderIdentity() {
  return "";
}

export function getProfileTypeMeta(value) {
  const normalizedValue = normalizeProfileType(value);

  return PROFILE_TYPE_OPTIONS.find((option) => option.value === normalizedValue) || null;
}

export function getGenderIdentityMeta() {
  return null;
}
